import { useMemo } from "react";
import { FormElement } from "@helpers/types";
import { useProfileSelectOptions } from "@features/settings/SettingsProfile/useProfileSelectOptions";

export const useProfileFormFields = () => {
  const { genderOptions, academicTitleOptions } = useProfileSelectOptions();
  return useMemo<FormElement[]>(
    () => [
      {
        name: "gender",
        type: "select",
        options: genderOptions,
        testId: "select-gender",
      },
      {
        name: "academicTitle",
        type: "select",
        options: academicTitleOptions,
        testId: "select-academic-title",
        optional: true,
      },
      {
        name: "firstName",
        type: "text",
        testId: "input-first-name",
      },
      {
        name: "lastName",
        type: "text",
        testId: "input-last-name",
      },
    ],
    [genderOptions, academicTitleOptions]
  );
};
